export class Base {

    constructor() {
        console.log("[evenfive.bremen.europapunkt]", "[Base]");

        /**
         * Disable transitions caused by window resize.
         */
        var timeout: any = null;
        window.addEventListener("resize", () => {
            document.body.classList.add("no-transition");
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                document.body.classList.remove("no-transition");
            }, 50);
        });

        jQuery(function ($) {

            // Add appointment stempel in contact box of erasmus page, if there is the appointment date
            if ($('.erasmus-termin .column_attr').text().length > 0) {
                var terminDate = $('.erasmus-termin .column_attr').text();
                $('.erasmus-termin').hide();
                $('.stempel-date').text(terminDate);
            } else {
                $('.erasmus-termin').hide();
                $('.stempel').hide();
            }

            // Add Newsletter Button into the page
            if ($("body.epb-base__hide-newsletter-button").length > 0) {

            }
            else {
                $('#Content').append('<button class="newsletter-button"><div class="newsletter-button-text">Newsletter <i class="icon-down-thin"></i></div></button>');

                var form = $('#mailpoet_form_1');
                form.append('<button class="button newsletter-close" aria-label="Newsletter Formular schließen"><i class="icon-cancel-circled"></i></button>');

                var button = $('.newsletter-button');
                button.on('click', function () {
                    form.removeClass('close');
                    form.addClass('open');
                    button.removeClass('show');
                    button.addClass('hide');
                    $('#mailpoet_form_1 input, #mailpoet_form_1 a, #mailpoet_form_1 button').attr('tabindex', '0');
                });

                button.keydown(function (e) {
                    if (e.keyCode == 13) {
                        button.click();
                    }
                });

                var close = $('.newsletter-close');
                close.on('click', function () {
                    form.removeClass('open');
                    form.addClass('close');
                    setTimeout(function () {
                        button.removeClass('hide');
                        button.addClass('show');
                    }, 500);
                    $('#mailpoet_form_1 input, #mailpoet_form_1 a, #mailpoet_form_1 button').attr('tabindex', '-1');
                });

                close.keydown(function (e) {
                    if (e.keyCode == 13) {
                        close.click();
                    }
                });
            }

            if ($('.newsletter-button').hasClass('hide')) {
            } else {
                $('#mailpoet_form_1 input, #mailpoet_form_1 a, #mailpoet_form_1 button').attr('tabindex', '-1');
            }


            // Add login button next to social icons in header
            var loginUrl = window.e5.Plugins.config.siteUrl + "/login";
            $('ul.social').append('<li class="login"><a href="' + loginUrl + '">Anmelden</i></a></li>');

            var logoutUrl = window.e5.Plugins.config.siteUrl + "/logout";
            $('body.logged-in ul.social').append('<li class="logout"><a href="' + logoutUrl + '">Abmelden</i></a></li>');


            // If this single post is a europawoche event, add the button to go back the previous page
            if ($('body.single-event').length) {
                $('#Content .post-header').prepend('<div class="back-events"><div class="back-button" onclick="history.back();"><i class="icon-left-thin"></i> Zurück zur Liste</div></div>');
            }

            // Fix isotope display
            $('.isotope.masonry, .isotope.masonry-hover, .isotope.masonry-minimal').isotope({
                masonry: {
                    //@ts-ignore
                    horizontalOrder: true,
                    columnWidth: '.isotope-item'
                }
            });

            // Make isotope in veranstaltungen list
            $('body.page-id-16 .em-events-list').isotope({
                itemSelector: '.em-event',
                layoutMode: 'masonry',
                masonry: {
                    //@ts-ignore               
                    horizontalOrder: true,
                    columnWidth: '.em-event'
                }
            });


            // Make isotope from collage images
            $('.photo-collage-wrapper > .mcb-wrap-inner ').isotope({
                itemSelector: '.column',
                layoutMode: 'masonry'
            });

            // Add notice text to custom attributes in event form
            $('.event-attributes.Veranstalter').prepend('<h3>Weitere Informationen die öffentlich angezeigt werden</h3>');

            $('.event-attributes.Veranstalter > label').html('Veranstalter*innen <p>Bitte geben  die Namen aller beteiligten Einrichtungen ein mit einem Komma als Trennung. (wie. Z.B.  EFRE, ESF) </p>');

            $('.event-attributes.Alttext > label').html('Alternativtext <p>Dieser wird für die Barrierefreiheit benötigt. </p>');

            $('#em-location-search-tip').html('<div style="margin-top: -24px; font-size: 13px;">Erstellen Sie einen Veranstaltungsort. Wenn der Veranstaltungsort bereits vorhanden ist, werden ihre Angaben automatisch ergänzt.</div>');


            $('.em-location-data-address > th').text('Straße');

            $('tr.em-location-data-url > td').append('<div style="margin-top: -17px; font-size: 13px; font-style: italic;">Geben Sie eine Webseite mit "https://" ein.</div>');


            // Add notice text to register form
            $('#um_field_231_user_password .um-field-label label').append('<p>Dein Password muss mindestens 8 Zeichen lang sein, und mindestens einen Kleinbuchstaben, einen Großbuchstaben und eine Zahl enthalten</p>');

            var privacyUrl = window.e5.Plugins.config.siteUrl + "/datenschutz/";
            $('.um-field-type_terms_conditions').prepend('<a href="' + privacyUrl + '" target="_blank">Datenschutzerklärung zeigen</a>');


            // If the filter 'Online/Offline' online is, city filter is deactive.
            $("select[name=place]").change(function () {
                $('.em-submit-section .button-primary').removeClass('disabled');
                var selectedOption = $(this).children("option:selected").val();
                console.log(selectedOption);
                if (selectedOption === '1') {
                    $('.em-search-location').hide();
                } else {
                    $('.em-search-location').show();
                }
            });


            //********************************* */
            // Barrierfreiheit***************** */
            //********************************* */

            // Add Arial-Label
            $('.responsive-menu-toggle').attr('aria-label', 'mobiles Menü');
            $('.icon-cancel-fine').attr('aria-label', 'Menü schließen');
            $('.responsive-menu-toggle').click(function () {
                setTimeout(() => {
                    $('.menu-toggle').attr('aria-label', 'Untermenü umschalten');
                }, 500);
            });

            $('.mailpoet_submit').attr('aria-label', 'Button zum Abbonieren');
            $('.popup-content .mfp-close').attr('aria-label', 'Fenster schließen');
            $('#Side_slide .close').attr('aria-label', 'Menü schließen');

            $('.mailpoet_text#form_email_1').attr('aria-label', 'E-Mail-Adresse');
            $('.mailpoet_text#form_first_name_1').attr('aria-label', 'Vorname');
            $('.mailpoet_text#form_last_name_1').attr('aria-label', 'Nachname');
            $('.mailpoet_checkbox').attr('aria-label', 'Kontrollkästchen');
            $('.mailpoet_submit').attr('aria-label', 'Button zum Abbonieren');

            $('.popup-image').on("click", function () {
                $('.popup-content .mfp-close').attr('aria-label', 'Fenster schließen');
            });


            $('#Side_slide').removeAttr('aria-expanded');
            $('.responsive-menu-toggle').attr('aria-expanded', 'false');

            $('i').removeAttr('aria-label');
            $('.social .facebook a').attr('aria-label', 'Link zu Facebook');
            $('.social .twitter a').attr('aria-label', 'Link zu Twitter');
            $('.social .vimeo a').attr('aria-label', 'Link zu Vimeo');
            $('.social .instagram a').attr('aria-label', 'Link zu Instagram');

            // Tabindex
            if ($('#Header').find('#menu').length !== 0) {
                $('#Side_slide a').attr('tabindex', '-1');
            }

            $('#um-submit-btn.um-button').attr('tabindex', '0');
            $('.um-button.um-alt').attr('tabindex', '0');
            $('.um-field-checkbox input').attr('tabindex', '0');

            $('#BorlabsCookieBox a').removeAttr('tabindex');


            // Add skiplink
            $('body').prepend('<a class="skiplink" href="#menu">skip to navigation</a>');

            // disable link
            var blogImageLinks = $('.post-item .image_frame a, .post-related .image_frame a');
            blogImageLinks.each(function () {
                $(this).replaceWith('<div role="presentation" tabindex="-1">' + $(this).html() + '</div>');
            });

            // Add link text
            $('.share-simple-wrapper .icons a.facebook').attr('aria-label', 'Teile den Beitrag auf Facebook').append('<span class="sr-only">Teile den Beitrag auf Facebook</span>');
            $('.share-simple-wrapper .icons a.twitter').attr('aria-label', 'Teile den Beitrag auf Twitter').append('<span class="sr-only">Teile den Beitrag auf Twitter</span>');
            $('.share-simple-wrapper .icons a.linkedin').attr('aria-label', 'Teile den Beitrag auf Linkedin').append('<span class="sr-only">Teile den Beitrag auf Linkedin</span>');
            $('.share-simple-wrapper .icons a.pinterest').attr('aria-label', 'Teile den Beitrag auf Pinterest').append('<span class="sr-only">Teile den Beitrag auf Pinterest</span>');

            // Add text
            $('.um-field-label .um-req').append('Pflichtfeld');

        });
    }
}

document.addEventListener("DOMContentLoaded", (e) => {
    new Base();
});